var React = require('react');

function Section1TopRightInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("polygon",{"fill":"#C5F6D5","points":"35.345 23.967 62.359 97.167 8.33 97.167","transform":"rotate(-105 35.345 60.567)","key":0}),React.createElement("circle",{"cx":"103.596","cy":"16.596","r":"16","fill":"#1765AB","transform":"rotate(-105 103.596 16.596)","key":1})]));
}

Section1TopRightInline.defaultProps = {"width":"120","height":"78","viewBox":"0 0 120 78"};

module.exports = Section1TopRightInline;

Section1TopRightInline.default = Section1TopRightInline;
